module.exports = __webpack_public_path__ + "img/img-7.33806e22.png";